export default {
  dashboard: {
    id: 1,
    label: 'Dashboard',
    path: '/dashboard',
    icon: 'dashboard'
  },
  clocktime: {
    id: 2,
    label: 'Clock In/Out',
    path: '/clock-time',
    icon: 'timer'
  },
  carriers: {
    id: 3,
    label: 'Carriers',
    path: '/carriers',
    icon: 'directions_bus'
  },
  quotes: {
    id: 4,
    label: 'Quotes',
    path: '/quotes',
    icon: 'card_travel'
  },
  followups: {
    id: 5,
    label: 'Followups',
    path: '/followups',
    icon: 'schedule',
    color: 'brand2'
  },
  orders: {
    id: 6,
    label: 'Orders',
    path: '/orders',
    icon: 'card_giftcard',
    color: 'brand3'
  },
  dispatch: {
    id: 7,
    label: 'Dispatch',
    path: '/dispatch',
    icon: 'local_shipping',
    color: 'red-14'
  },
  reports: {
    id: 8,
    label: 'Reports',
    path: '/reports',
    icon: 'event_note',
    color: 'deep-purple-10'
  },
  users: {
    id: 9,
    label: 'Users',
    path: '/users',
    icon: 'people'
  },
  taq: {
    id: 10,
    label: 'Pricing',
    path: '/taq',
    icon: 'attach_money'
  },
  priceCheck: {
    id: 11,
    label: 'Price Check',
    path: '/price-check',
    icon: 'price_check'
  },
  settings: {
    id: 12,
    label: 'Settings',
    path: '/settings',
    icon: 'settings'
  },
  surveyList: {
    id: 13,
    label: 'Survey',
    path: '/survey-list',
    icon: 'warning'
  }
};
